<template>
		<el-dialog
			title=""
			:visible.sync="errordialog.open"
			width="fit-content"
			:append-to-body="true"
			:show-close="false"
			custom-class="error"
			destroy-on-close>
			<template slot="title">
				<div class="grid header">
					<div class="title" style="font-size: 20px;">{{errordialog.title}}</div>
				</div>
			</template>
			<div>{{errordialog.message}}</div>
			<div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
				<span class="btn reddark sm" @click="$emit('close')"><unicon name="thumbs-up" fill="#fff" /> ok, chiudi la finestra</span>
			</div>
		</el-dialog>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
	name: 'Errordialog',
	// mixins: [helper],
	props: {
		errordialog: Object
	},
	data () {
	return {
		changes: false
	}
	},
	methods: {
		show (section) {
			console.log(section)
			this.$emit('open', section)
		},
		save () {
			console.log('save')
			// this.$store.dispatch('hotels/updateHotel', this.hotel)
		}
	},
	filters: {

	},
	watch: {

	},
	computed: {

	},
	beforeMount () {

	},
	beforeDestroy () {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
